export default "<span *ngFor='let sep of labelSep; index as i'\n      [ngClass]='{\"italic\": sepValue[i].indexOf(\"TRANS__\") === 0}'>{{sep}}</span>\n"